function normalizeGiftCardDetails(details) {
  return {
    ...details,
    cardNumber: details.cardNumber.replace(/[^0-9a-zA-Z]/g, ''),
    pin: details.pin ? details.pin.replace(/[^0-9a-zA-Z]/g, '') : undefined
  };
}



export default normalizeGiftCardDetails;
